import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  async getCurrencies(): Promise<string[]> {
    const response = await axios.get(`${environment.baseUrl}/api/currency`);
    return response.data.currencies;
  }
}